import { AppDispatch } from 'app/hooks/appHooks';
import { StoreTranslationsDateField } from 'app/models/types/store/translations';
import { fetchDatesTranslations, fetchTranslations } from 'app/providers';
import { requestTranslationsSucceeded } from 'app/store/reducers/translation';

export const requestTranslations = (locale: string) => async (dispatch: AppDispatch) => {
  const [translationsResponse, translationsDatesResponse]: [
    { [key: string]: string },
    StoreTranslationsDateField,
  ] = await Promise.all([fetchTranslations(locale), fetchDatesTranslations(locale)]);

  dispatch(
    requestTranslationsSucceeded({
      strings: translationsResponse,
      dates: translationsDatesResponse,
    }),
  );
};
